import { gql } from "@apollo/client";

export const CREATE_SUBMISSION = gql`
  mutation CreateSubmission(
    $email: String!
    $message: String
    $contactpreference: String
    $notes: NotesInput
    $parentname: String
    $phone: String
    $referralOther: String
    $referralSource: String
    $studentname: String
  ) {
    createSubmission(
      email: $email
      message: $message
      contactpreference: $contactpreference
      notes: $notes
      parentname: $parentname
      phone: $phone
      referralOther: $referralOther
      referralSource: $referralSource
      studentname: $studentname
    ) {
      id
      email
      message
      contactpreference
      notes {
        content
      }
      parentname
      phone
      referralOther
      referralSource
      studentname
    }
  }
`;
